// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-qrcode[data-v-a99c4ecc] {\n  margin-top: 10px;\n}\n.partner-logo[data-v-a99c4ecc] {\n  max-width: 160px;\n  max-height: 160px;\n  border: 1px solid #d2d6de;\n  padding: 4px;\n  background: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
